import { useCallback } from "react";
import { useToaster } from "@design-system/ToastMessages/useToaster";

interface UseCopyToClipboardOptions {
    successMessage?: string;
    errorMessage?: string;
}

export function useCopyToClipboard(options: UseCopyToClipboardOptions = {}) {
    const { toast, error: errorToast } = useToaster();
    const {
        successMessage = "Copied to clipboard",
        errorMessage = "Failed to copy to clipboard",
    } = options;

    const copyToClipboard = useCallback(
        async (text: string) => {
            try {
                await navigator.clipboard.writeText(text);
                toast(successMessage);
                return true;
            } catch {
                errorToast(errorMessage);
                return false;
            }
        },
        [toast, errorToast, successMessage, errorMessage],
    );

    return copyToClipboard;
}
